import(/* webpackMode: "eager" */ "/vercel/path0/app/(routes)/privacy-policy/page.jsx");
